import { useAddContentModalStore } from '../..';

/**
 * Determine whether or not we should render the modal overlay.
 *
 * Normally we piggyback off the SharedModalOverlay to ensure seamless
 * transtions between modals (add content -> click manual -> create manually,
 * for example) but in case the EntryModal is nested on top of another modal,
 * we need to render the overlay ourselves.
 */
export const useRenderModalOverlay = () => {
  const { isOpen: isAddContentModalOpen } = useAddContentModalStore();
  const renderModalOverlay = isAddContentModalOpen ? true : false;

  return { renderModalOverlay };
};
